/* eslint-disable import/no-anonymous-default-export,import/no-default-export */
import { quickWinsTypography } from '@clds/feature-flags';
const interUrl = 'https://fonts.googleapis.com/css?family=Inter:300,300i,400,400i,500,500i,600,600i,700,700i&display=swap';
const firaUrl = 'https://fonts.googleapis.com/css?family=Fira+Sans:300,300i,400,400i,500,500i,600,600i,700,700i&display=swap';
export default () => ({
    font: Object.assign({ size: '16px' }, quickWinsTypography
        .whenEnabled({ family: '"Inter", sans-serif', url: interUrl })
        .orElse({ family: '"Fira Sans", sans-serif', url: firaUrl })),
    focus: {
        color: '#005CE4',
    },
    background: {
        color: '#E4EBF1',
    },
});
//# sourceMappingURL=globals.js.map